var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_vert-new_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m242.8,94c0-15.77-12.83-28.6-28.6-28.6s-28.6,12.83-28.6,28.6,12.83,28.6,28.6,28.6,28.6-12.83,28.6-28.6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 214.2,
    cy: 214.6,
    r: 28.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m242.8,335.2c0-15.77-12.83-28.6-28.6-28.6s-28.6,12.83-28.6,28.6,12.83,28.6,28.6,28.6,28.6-12.83,28.6-28.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertNew);
export default __webpack_public_path__ + "static/media/more_vert-new.3e343d37e57132fa3935c818d84288f5.svg";
export { ForwardRef as ReactComponent };